import _ from 'underscore';
import Backbone from 'backbone';
import pageContext from '@bingads-webui-static-legacy/page-context';
import expDateUtils from '@bingads-webui-campaign-legacy/experiments-tab/experiment-date-utils-loader';
import template from './template.pug';

const isExperimentsOpenBetaEnabled = _.result(pageContext.Permissions, 'IsExperimentsOpenBetaEnabled');

export class PopupContentView extends Backbone.View {
  initialize({ targetEntity, i18n, eventName = '', isForecasting = false}) {
    this.entity = targetEntity;
    this.i18n = i18n;
    this.eventName = eventName;
    this.isForecasting = isForecasting;
  }

  get events() {
    return {
      'click .budget-landscape-action-link': 'actionClicked',
    };
  }

  actionClicked(event) {
    this.trigger('budget-landscape-action-link:clicked', {event});
  }

  template() {
    const params = {
      i18n: this.i18n,
      deliveryStatus: this.entity.DeliveryStatus,
      landscapeDisabled: this.entity.landscapeDisabled,
      eventName: this.eventName,
      isForecasting: this.isForecasting,
    };

    if (isExperimentsOpenBetaEnabled && this.entity.ExperimentId && this.entity.AssociatedExperiment) {
      params.ExperimentId = this.entity.ExperimentId;
      params.AssociatedExperiment = this.entity.AssociatedExperiment;
      params.percentSymbol = pageContext.DecimalFormatter.percentSymbol;
      params.expDateUtils = expDateUtils;
    }

    return template(params);
  }

  render () {
    this.$el.html(this.template());

    return this;
  }
}
